import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VForm,[_c(VCard,[_c(VCardText,[_c('h4',{staticClass:"primary--text"},[_vm._v("\n          "+_vm._s(_vm.$route.params.notificationTypeId ? "Edit" : "Create")+" Notification\n          Type\n        ")])]),_c('gru-form-base',{attrs:{"layout":"column","value":_vm.notificationType,"schema":_vm.mySchema,"doSubmit":_vm.doSubmit,"doBack":_vm.doBack}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }